import { render, staticRenderFns } from "./set14.vue?vue&type=template&id=4d7d9bca&scoped=true&"
import script from "./set14.vue?vue&type=script&lang=js&"
export * from "./set14.vue?vue&type=script&lang=js&"
import style0 from "./set14.vue?vue&type=style&index=0&id=4d7d9bca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7d9bca",
  null
  
)

export default component.exports